import React from "react";
import classNames from "classnames";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function Section({ title, children }: Props) {
  return (
    <VisibilitySwitch
      renderChildren={(isHidden, hide, show) => (
        <div className={styles.section}>
          <div className={styles.header} onClick={!isHidden ? hide : show}>
            <div
              className={classNames(styles.iconBox, {
                [styles.toggled]: isHidden,
              })}
            >
              <ToggleArrow className={styles.icon} />
            </div>
            <h3 className={styles.title}>{title}</h3>
          </div>
          {!isHidden && <div className={styles.content}>{children}</div>}
        </div>
      )}
    />
  );
}

export { Section };
